import { CheckboxList } from "@monsterindia/global-ui-components";
import { FC, memo } from "react";
import { Controller } from "react-hook-form";

import { LgbtqiaApopControllerType } from "../../../../../../types/apop";
import { ErrorText } from "../../../../common/ErrorText";

type CheckBoxControllerProps = {
  options: { displayName: string; id: string; value: string }[];
} & LgbtqiaApopControllerType;

const CheckBoxController: FC<CheckBoxControllerProps> = ({
  name,
  control,
  options,
  errors,
  isRequired,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired }}
      render={({ field }) => {
        return (
          <div className="l1-flex l1-flex-row l1-gap-1">
            <CheckboxList
              eventChangeHandler={() => {
                field.onChange(!field.value);
              }}
              size="large"
              options={options}
              defaultChecked={field?.value ? ["1"] : [""]}
            />
            {isRequired && <span className="l1-mt-1 l1-text-red-500">*</span>}
            {errors[name] && (
              <ErrorText
                text={errors[name]?.message || "This field is required"}
              />
            )}
          </div>
        );
      }}
    />
  );
};

export default memo(CheckBoxController);
